import { first } from 'lodash';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

type Route = {
  name: string;
  path: string;
  accesses: string[];
  hiddenInNav?: boolean;
};
type Props = {
  privateRoutes: Route[];
};
export const RedirectComponent = ({ privateRoutes }: Props) => {
  const history = useHistory();
  const firstPath = privateRoutes.find(
    (route) =>
      route.name !== 'INDEX' && route.name !== 'LOGIN' && !route.hiddenInNav
  )?.path;

  useEffect(() => {
    if (firstPath && window.location.pathname === '/') {
      history.push(firstPath);
    }
  }, [firstPath]);
  return <div></div>;
};
